import { z } from 'zod'
import { INTENT_ID_RE, SCREEN_ID_RE } from './ids'

export const INTENT_STATUSES = ['gap', 'wip', 'proven', 'wontfix', 'deferred'] as const
export type IntentStatus = (typeof INTENT_STATUSES)[number]

export const IntentItemSchema = z.object({
  intent_id: z.string().regex(INTENT_ID_RE, 'intent_id must be dotted/kebab segment'),
  app: z.string().min(1),
  screen_id: z.string().regex(SCREEN_ID_RE).optional(),
  roles: z.array(z.string().min(1)).min(1),
  claim: z.string().min(1),
  status: z.enum(INTENT_STATUSES),
  /** Structured acceptance criteria — non-empty strings only (no free-form blob). */
  acceptance: z.array(z.string().min(1)).min(1),
  links: z
    .array(
      z.object({
        rel: z.string().min(1),
        href: z.string().min(1),
      }),
    )
    .optional(),
})

export type IntentItem = z.infer<typeof IntentItemSchema>
